<template>
  <div>
    <div class="dateText text-center">
      <p>Сүүлийн 24 сарын худалдан авалтын график</p>
      <span>{{ dateStr }}</span>
    </div>
    <canvas id="bonus-chart" style="width: 100%; height: 400px"></canvas>
    <div class="row" style="padding-bottom: 50px">
      <div class="col-md-6 width100">
        <button
          class="chartBtn"
          :class="this.filterType === 'Month' ? 'activeColor' : ''"
          @click.esc="showChartMonth"
          :disabled="isCalled"
        >
          Сар
        </button>
        <button
          class="chartBtn"
          :class="this.filterType === 'Season' ? 'activeColor' : ''"
          @click.esc="showChartSeason"
          :disabled="isCalled"
        >
          Улирал
        </button>
        <button
          class="chartBtn"
          :class="this.filterType === 'Year' ? 'activeColor' : ''"
          @click.esc="showChartYear"
          :disabled="isCalled"
        >
          Жил
        </button>
      </div>
      <div class="col-md-6 width100">
        <div
          class="checkText text-right"
          style="float: right; margin-right: 5px"
        >
          <div
            style="float: left; margin-top: 3px; margin-right: 5px"
            class="noneT"
          >
            <input
              type="checkbox"
              id="checkbox"
              v-model="checked"
              @change="changeCheckBox()"
              :disabled="isCalled"
            />
          </div>
          <div style="float: left" class="noneT">
            <label for="checkbox">Хамтран эзэмшигчтэй хамт харах</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
      isPartner: 1,
      filterType: "Month",
      chartType: "",
      isCalled: false,
      dateStr: "",
      data: {
        labels: [],
        datasets: [],
      },
      options: {
        responsive: true,
        lineTension: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 15,
                callback: function (value, index, values) {
                  if (parseInt(value) >= 1000 && parseInt(value) < 10000) {
                    return value
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  } else if (
                    parseInt(value) >= 10000 &&
                    parseInt(value) < 1000000
                  ) {
                    var tmpValue = parseInt(value) / 1000;
                    return tmpValue + " K";
                  } else if (
                    parseInt(value) >= 1000000 &&
                    parseInt(value) < 1000000000
                  ) {
                    var tmpValue = parseInt(value) / 1000000;
                    return tmpValue + " M";
                  } else {
                    return value;
                  }
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function (t, d) {
              var xLabel = d.datasets[t.datasetIndex].label;
              var yLabel =
                t.yLabel >= 1000
                  ? "₮ " +
                    t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "₮ " + t.yLabel;
              return xLabel + ": " + yLabel;
            },
          },
        },
      },
    };
  },
  methods: {
    changeCheckBox() {
      this.isPartner = this.checked ? 1 : 0;
      this.createChart();
    },
    showChartMonth() {
      this.filterType = "Month";
      this.chartType = "line";
      this.createChart();
    },
    showChartSeason() {
      this.filterType = "Season";
      this.chartType = "line";
      this.createChart();
    },
    showChartYear() {
      this.filterType = "Year";
      this.chartType = "bar";
      this.createChart();
    },
    createChart() {
      this.isCalled = true;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      var type = this.filterType === "" ? "Month" : this.filterType;
      if (this.chartType === "") this.chartType = "line";
      var isPartner = this.isPartner;
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/chart`,
          // `card/chart`,
          { tokenId, cardHolderInfId, type, isPartner },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            this.data.labels = results.labels;
            this.data.datasets = results.datasets;
            this.dateStr = results.dateStr;
            const ctx = document.getElementById("bonus-chart");
            const myChart = new Chart(ctx, {
              type: this.chartType,
              data: this.data,
              options: this.options,
            });
            myChart.update();
            setTimeout(() => {
              this.isCalled = false;
            }, 2000);
          }
        })
        .catch((error) => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
  mounted() {
    this.createChart();
  },
};
</script>

<style>
.chartBtn {
  background-color: #92919f;
  opacity: 0.7;
  color: #fff;
  border: none;
  padding: 5px 20px;
  border-radius: 8px;
  font-size: 12px;
  width: 80px;
  margin-left: 5px;
  margin-top: 20px;
}
.chartBtn.activeColor {
  background: #1660ab;
  opacity: 1;
}
.checkText {
  margin: 0;
  padding: 0;
  padding-top: 24px;
  font-size: 12px;
  color: #939393;
}
.dateText {
  margin: 0;
  padding: 0;
  padding-top: 20px;
  padding-bottom: 20px;
}
.dateText p {
  margin: 0;
  padding: 0;
  color: #1660ab;
  font-size: 18px;
}
.dateText span {
  margin: 0;
  padding: 0;
  padding-top: 0;
  color: #939393;
  display: block;
  font-size: 14px;
  font-style: italic;
}
@media screen and (max-width: 767px) {
  .width100 {
    width: 100%;
  }
  .col-md-1 {
    padding-left: 15px;
  }
  .col-md-10 {
    padding-left: 5px;
  }
}
</style>
